import classnames from 'classnames';
import React from 'react';
import { pluralize } from 'swag-common/utils/strings';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import CustomRadioButton from 'swag-client-common/components/ui/radio-button';
import classes from './time-table.scss';
export const TimeTable = ({
  onChange,
  prodTime,
  timeList,
  editAvailable,
  isBox,
  tableClassName,
  isLimitedEdition
}) => /*#__PURE__*/React.createElement("table", {
  className: classnames(classes.table, tableClassName),
  "data-table": "ProductionTime"
}, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null, "Service"), /*#__PURE__*/React.createElement("th", null, "Time"), /*#__PURE__*/React.createElement("th", null, "Cost"))), /*#__PURE__*/React.createElement("tbody", null, timeList.map(({
  name,
  cost,
  time
}, prodTimeIndex) => /*#__PURE__*/React.createElement("tr", {
  key: name,
  className: classnames({
    [classes.active]: prodTime === prodTimeIndex && editAvailable,
    [classes.interactive]: editAvailable
  }),
  onClick: () => onChange(prodTimeIndex),
  tabIndex: editAvailable ? 0 : -1,
  onKeyDown: e => handleOnEnterPressed(e, () => onChange(prodTimeIndex)),
  "aria-label": name
}, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(CustomRadioButton, {
  checked: prodTime === prodTimeIndex && editAvailable,
  onClick: () => onChange(prodTimeIndex),
  className: classnames(classes.radioButton, {
    [classes.orange]: isLimitedEdition
  })
})), /*#__PURE__*/React.createElement("td", {
  "data-cell": "Name"
}, name), /*#__PURE__*/React.createElement("td", {
  "data-cell-days": time
}, pluralize(time, 'Business day', 's')), /*#__PURE__*/React.createElement("td", {
  "data-cell": "Cost"
}, cost === 0 ? 'Free' : `${(cost * 100).toFixed(0)}%`, isBox && cost !== 0 && ' or less')))));